import React from 'react';
import { Modal, Spinner } from 'react-bootstrap';
import { isFirefox } from '~/util';
import { BSModal } from '~/components/Bootstrap';
import { ClientContext } from '~/services';

export interface BookmarkModalProps {
    handleClose: () => void;
    patientGmpi?: number | null;
    fileId: string;
    bookmarkPage?: string;
    isHistoricDoc?: boolean;
}

export function BookmarkModal({
    handleClose,
    patientGmpi,
    fileId,
    bookmarkPage = '',
    isHistoricDoc = false,
}: BookmarkModalProps) {
    const { reportYear } = React.useContext(ClientContext);
    const [loading, setLoading] = React.useState(true);

    const path = `/wellmed/api/gmpi/${patientGmpi}/bookmark-documents/${fileId}?report_year=${reportYear}#toolbar=0${
        bookmarkPage ? `&page=${bookmarkPage}` : ''
    }`;

    return (
        <BSModal
            className="bookmark-document-modal preview-modal"
            show
            onHide={handleClose}
            aria-labelledby="bookmark-document-title"
        >
            <Modal.Header closeButton>
                <Modal.Title id="bookmark-document-title" role="heading" aria-level={1}>
                    {!isHistoricDoc ? 'Bookmarked Document' : 'Historic Document'}
                </Modal.Title>
            </Modal.Header>
            <Modal.Body>
                {loading && (
                    <div className="text-center mt-3">
                        <Spinner animation="border" />
                    </div>
                )}
                {!loading && bookmarkPage && (
                    <div className="mb-2">Bookmark Page Number: {bookmarkPage}</div>
                )}

                {/* Firefox doesn't respond to the object events, so use iframe instead */}
                {!isFirefox ? (
                    <object
                        type="application/pdf"
                        className="media-preview-size"
                        aria-label="Media Preview"
                        data={path}
                        onLoad={() => setLoading(false)}
                    >
                        <embed
                            id="bookmark-document-pdf-embed"
                            type="application/pdf"
                            className="media-preview-size"
                            src={path}
                        />
                    </object>
                ) : (
                    <iframe
                        className="media-preview-size"
                        onLoad={() => setLoading(false)}
                        src={path}
                        title="Media Preview"
                    />
                )}
            </Modal.Body>
        </BSModal>
    );
}
